import {LeadTopicType} from "../../types/lead/LeadTopicType";

interface ILeadTopicConfig {
    title: string;
    message: string;
}

export const leadTopicConfig: Record<LeadTopicType, ILeadTopicConfig> = {
    [LeadTopicType.PARKING]: {
        title: "Zapytaj o dostępność miejsc postojowych",
        message: "Dzień dobry, proszę o przesłanie informacji odnośnie ceny i dostępności miejsc postojowych."
    },
    [LeadTopicType.CUSTOM]: {
        title: "",
        message: ""
    }
};
import {LeadTopicType} from "../../types/lead/LeadTopicType";

interface ILeadTopicConfig {
    title: string;
    message: string;
}

export const leadTopicConfig: Record<LeadTopicType, ILeadTopicConfig> = {
    [LeadTopicType.PARKING]: {
        title: "Zapytaj o dostępność miejsc postojowych",
        message: "Dzień dobry, proszę o przesłanie informacji odnośnie ceny i dostępności miejsc postojowych."
    },
    [LeadTopicType.CUSTOM]: {
        title: "",
        message: ""
    }
};
